export const iconFontAwesomeDesignCircleNodes = (
	<i className="fa-solid fa-circle-nodes"></i>
);
